module.exports = __webpack_public_path__ + "img/9-r.7bdbb844.png";